import { render, staticRenderFns } from "./NewsTicker.vue?vue&type=template&id=3abc7f14&"
import script from "./NewsTicker.vue?vue&type=script&lang=js&"
export * from "./NewsTicker.vue?vue&type=script&lang=js&"
import style0 from "./NewsTicker.vue?vue&type=style&index=0&id=3abc7f14&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3abc7f14')) {
      api.createRecord('3abc7f14', component.options)
    } else {
      api.reload('3abc7f14', component.options)
    }
    module.hot.accept("./NewsTicker.vue?vue&type=template&id=3abc7f14&", function () {
      api.rerender('3abc7f14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tips/NewsTicker.vue"
export default component.exports